import { CommentType } from 'APIs/BackstageCommentApi';
import OtrCommentInput from 'components/atoms/Inputs/OtrCommentInput';
import OtrCardCommentListsWithData from 'components/molecules/Card/OtrCardCommentListsWithData';
import { selectAuth } from 'features/auth/authSlice';
import { OtrData } from 'interfaces/OtrData.interface';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

interface IVideoProps {
  otr: OtrData;
  index: number;
  playVideo: () => void;
  showComments: boolean;
  nextVideo: () => void;
}

const OtrVideo = ({
  otr,
  index,
  playVideo,
  showComments,
  nextVideo,
}: IVideoProps) => {
  const authState = useSelector(selectAuth);
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    let options = {
      rootMargin: '0px',
      threshold: [0.25, 0.75],
    };

    let handlePlay = (entries: any, observer: any) => {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting && videoRef.current) {
          videoRef.current.src = otr.src_url;
          videoRef.current.play();
        } else if (videoRef.current && !entry.isIntersecting) {
          videoRef.current.pause();
        }
      });
    };

    let observer = new IntersectionObserver(handlePlay, options);
    if (videoRef.current) observer.observe(videoRef.current);
  }, [otr.src_url]);

  return (
    <div className={`player-container-player ${authState.id && 'logged-out'} `}>
      <video
        onClick={playVideo}
        id={`full-screenVideo${index}`}
        poster={otr.src_url}
        src={otr.src_url}
        muted={true}
        ref={videoRef}
        onEnded={() => (showComments ? undefined : nextVideo())}
        className={`${otr.isVertical ? 'vertical' : 'horizontal'} none`}
      ></video>

      <div
        style={{
          minHeight: otr.comments && otr.comments.length > 0 ? '0%' : undefined,
          width: videoRef.current
            ? videoRef.current?.clientWidth - 40
            : undefined,
        }}
        className={`${
          otr.isVertical
            ? showComments
              ? 'show-comments'
              : 'no-show-comments'
            : showComments
            ? 'show-comments-horizontal'
            : 'no-show-comments-horizontal'
        } ${!otr.isVertical && 'expanded-comments'} `}
      >
        <div className="comments-inner">
          {(!otr.comments || otr.comments.length === 0) && (
            <p>Your comments will appear here</p>
          )}
          {/* <Tips /> */}
          {authState.id ? (
            otr.comments ? (
              otr.comments
                .filter(item => !item.parent)
                .map((item, index) => {
                  return (
                    <OtrCardCommentListsWithData
                      otr={otr}
                      data={item}
                      key={item.id}
                      type={CommentType.OTR}
                    />
                  );
                })
            ) : (
              <></>
            )
          ) : (
            <></>
          )}
          {authState.id ? (
            <OtrCommentInput
              ownerId={otr.user.id}
              postId={`${otr.id}`}
              type={CommentType.OTR}
              otr={otr}
            />
          ) : (
            <h3 style={{ color: 'white' }}>Login to comment!</h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default OtrVideo;
